module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container no-padding"
  }, [_c('div', {
    staticClass: "klickpages-link"
  }, [_c('div', {
    staticClass: "kp-folder-table-title"
  }, [_c('div', {
    staticClass: "kp-folder-name"
  }, [_vm._v(_vm._s(_vm.$t('account.attributes.name')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate"
  }, [_vm._v(_vm._s(_vm.$t('account.attributes.type')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate"
  }, [_vm._v(_vm._s(_vm.$t('account.list.insert_date')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-actions"
  }, [_vm._v(_vm._s(_vm.$t('account.list.actions')))])]), _vm._v(" "), (_vm.accountList.length > 0) ? _c('div', {
    staticClass: "kp-list-item",
    attrs: {
      "ui-tree-handle": "",
      "folder-drop": "afterDrop"
    }
  }, _vm._l((_vm.accountList), function(item) {
    return _c('item', {
      key: item.id,
      attrs: {
        "account": item
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.accountList.length == 0) ? _c('div', [_c('empty-board')], 1) : _vm._e()]), _vm._v(" "), _c('edit-account'), _vm._v(" "), _c('delete-account')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec2c93ba","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/List.vue
// module id = 282
// module chunks = 1